import React from "react";

export const SendOutCollectionDetailContext = React.createContext(null);

export const useSendOutCollectionDetailContext = () => {
    const context = React.useContext(SendOutCollectionDetailContext);

    if (!context) throw new Error("SendOut Collection Detail Context not provided!");

    return context;
};
